(function ($) {
    "use strict";

    function isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    }

    function isMobile() {
        var mobile = false;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
            mobile = true;
        }
        return mobile;
    }

    function pageFeaturedHeight() {
        var featured = $('.i8b-item-featured--js');
        if (featured.length) {
            var heightItem = featured.outerHeight();
            $('.ibc-products-featured-image--js').css('height', heightItem * 2);
        }
    }

    jQuery(document).on('ready', function () {

        if ($('.section__featured-collections--v1').length) {
            pageFeaturedHeight();
        }

        var subscribe = $('.subscribe-section');
        if (isMobile()) {
            $('body').addClass('i8b-mobile');
            var width = $(window).width();
            if ($('.slideshow-section').length && width < 500) {
                var sliderShowItem = $('.slideshow .item');
                sliderShowItem.each(function (i) {
                    var image = $(this).data('image-mobile');
                    if (image) {
                        //$(this).attr('style', 'background: url(' + image + ') center center no-repeat; background-size: cover; height: 83vh;');
                      	$(this).attr('src', image);
                    }
                });
            }
            if (subscribe.length) {
                $('.video-desktop').remove();
            }
        } else {
            if (subscribe.length) {
                $('.video-mobile').remove();
            }
        }

        if (subscribe.length) {
            var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);

            if (!isIOS) {
                $('.video-ios').remove();
                $('.video-android').show();
            } else {
                $('.video-android').show();
                // $('.video-android').remove();
            }
        }

        if ($('.main-navigation').length) {
            var menu = $('.top-navigation .level-li');
            menu.each(function (i) {
                $(this).addClass('i8b-menu-tem-' + i);
                if (i > 0) {
                    $('.i8b-menu-tem-' + i).addClass('icon-menu');
                    $('.i8b-menu-tem-' + i + ' .level-top').prepend('<i class="menu-custom menu-custom-' + i + '"></i>');
                }

            });
        }
        if ($('.bs-navbar-collapse').length) {
            var menu = $('#mobile-menu .level-li');
            menu.each(function (i) {
                var title = $(this).find('.title').text();
                if (title == 'Shop' || title == 'shop') {
                    $(this).find('.title').html('shop all');
                }
            });
            var collapse = $('.bs-navbar-collapse .nav-accordion .collapse');
            collapse.addClass('menu-collapse');
        }

        if ($('.header-middle-area-2').length) {
            $(document.body).on('click', '.menu-icon--js', function () {
                $(this).addClass('open');
            });
            $(document.body).on('click', '.btn-close-aside-header', function () {
                $('.menu-icon--js').removeClass('open');
                $('.header--aside').removeClass('show-aside');
            });
        }
        if ($('.newsletter-form').length) {
            $(document.body).on('click', '#mce-EMAIL', function () {
                var validate = $('.newsletter-form .form-validate');
                validate.empty();
            });
            $(document.body).on('click', '#mc-embedded-subscribe', function () {
                var form = $('.newsletter-form');
                var validate = $('.newsletter-form .form-validate');
                var email = $(this).parent().find('input[type="email"]').val();
                if (isValidEmailAddress(email)) {
                    form.submit();
                } else {
                    validate.html('<span>Please validate email!</span>');
                }
                return false;
            });
        }

        if ($('.product-img-list').length) {
            var thumbLink = $('.media-list .thumb-link');
            thumbLink.each(function (i) {
                if (i === 0) {
                    $(this).addClass('active');
                }
            });
            var countMedia = thumbLink.length;
            var height = countMedia * 110;
            if (height > 555) {
                var heightF = 555;
            } else {
                var heightF = height;
            }
            $('.media-list').css('height', heightF);
            $(document.body).on('click', '.media-list .thumb-link', function () {
                $(this).parent().find('.thumb-link').removeClass('active');
                $(this).addClass('active');
            });

            var thumbHorizontalLink = $('.more-views-horizontal .thumb-link');
            thumbHorizontalLink.each(function (i) {
                if (i === 0) {
                    $(this).addClass('active');
                }
            });
            $(document.body).on('click', '.more-views-horizontal .thumb-link', function () {
                $(this).parent().parent().parent().parent().find('.thumb-link').removeClass('active');
                $(this).addClass('active');
            });
        }

        if ($('.mini-cart').length) {
            $(document.body).on('click', '.overlay-background.active', function () {
                $(this).removeClass('active');
                $('.mini-cart .cart-container .cart-wrapper').removeClass('show');
            });
        }

        if ($('.block-layered-nav').length) {
            var listFilter = $('.narrow-by-list .narrow-item');
            listFilter.each(function () {
                if ($(this).find('li.enable').length) {
                    $(this).addClass('show');
                }
            });
        }

        if ($('.select-collection-tab').length) {

            $(document.body).on('click', '.i8b-tab-collection .nav-tabs li a', function () {
                var urlBrowse = $(this).data('url');
                var textBrowse = $.trim($(this).text());
                var tabCollecton = $('.i8b-tab-collection');
                var btnMore = tabCollecton.find('.more-product .btn-all-product');
                if (textBrowse === 'All') {
                    btnMore.attr('href', '/collections/all').html('BROWSE All');
                } else {
                    btnMore.attr('href', urlBrowse).html('BROWSE ' + textBrowse);
                }
            });

            var i8bSelectTab = $('.i8b-select-tab--js');
            i8bSelectTab.on('change', function () {
                var url = $(this).val();
                var tabWrap = $('.i8b-tab-collection');
                if (url) {
                    tabWrap.find('.category-detail .tab-pane').removeClass('active');
                    $(url).addClass('active');
                }
                return false;
            });

            i8bSelectTab.each(function () {
                var $this = $(this),
                    numberOfOptions = $(this).children('option').length;

                $this.addClass('select-field-hidden');
                $this.wrap('<div class="select-field-wrap"></div>');
                $this.after('<div class="select-field-styled"></div>');

                var $styledSelect = $this.next('div.select-field-styled');
                $styledSelect.text($this.children('option').eq(0).text());

                var $list = $('<ul />', {
                    'class': 'select-field-options'
                }).insertAfter($styledSelect);

                for (var i = 0; i < numberOfOptions; i++) {
                    $('<li />', {
                        text: $this.children('option').eq(i).text(),
                        rel: $this.children('option').eq(i).val(),
                        url: $this.children('option').eq(i).data('url')
                    }).appendTo($list);
                }

                var $styledSelectOptions = $this.siblings('.select-field-options');
                var $listItems = $list.children('li');

                $styledSelect.on('click', function (e) {
                    e.stopPropagation();
                    $('div.select-field-styled.active').not(this).each(function () {
                        $(this).removeClass('active').next('ul.select-field-options').slideUp(200);
                    });
                    $(this).toggleClass('active').next('ul.select-field-options').slideToggle(200);
                });

                $listItems.on('click', function (e) {
                    e.stopPropagation();
                    $styledSelect.text($(this).text()).removeClass('active');
                    $this.val($(this).attr('rel'));
                    $list.hide();
                    $list.slideUp(200);
                    $this.trigger('change');
                    var urlBrowse = $(this).attr('url');
                    var textBrowse = $.trim($(this).text());
                    var tabCollecton = $('.i8b-tab-collection');
                    var btnMore = tabCollecton.find('.more-product .btn-all-product');
                    if (textBrowse === 'All') {
                        btnMore.attr('href', '/collections/all').html('BROWSE All');
                    } else {
                        btnMore.attr('href', urlBrowse).html('BROWSE ' + textBrowse);
                    }
                });

                $(document).on('click', function () {
                    $styledSelect.removeClass('active');
                    $styledSelectOptions.removeClass('active');
                    $list.slideUp(200);
                });

            });
        }
        if ($('.row-height').length) {
            $('.row-height .col-height').matchHeight();
        }
    });
    jQuery(window).on('load', function () {

        if ($('.blog').length) {

        }

    });
    jQuery(window).on('load resize', function () {
        if ($('.section__featured-collections--v1').length) {
            pageFeaturedHeight();
        }
        if ($('.row-height').length) {
            $('.row-height .col-height').matchHeight();
        }
    });
  
  	if ($('.product-layout-grid').length) {
        $('.update-image').matchHeight();
    }
  

})(jQuery);